declare global {
  interface Window {
    game: () => void
    dataLayer: Record<string, unknown>[]
    __matheus: unknown
  }
}

const FROG = `
    .'_\`--.___
   ( 'o\`   - .\`.'_ )
    \`-._      \`_\`./_
      '/\\\\    ( .'/ )
     (__//\`---'\`-'_/
`

const POEM = `Entre meus punhos fechados
ossos quebrados
dentes cerrados
no meu coração se encontra você.`

function trackEgg(location: string) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: 'easter_egg_found', location, ts: Date.now() })
  try {
    const body = JSON.stringify({ event: 'easter_egg_found', location, page: window.location.pathname })
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api-event', new Blob([body], { type: 'application/json' }))
    } else {
      fetch('/api-event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true })
    }
  } catch { /* ignore */ }
}

export function initConsole() {
  const mono = 'font-family: monospace; font-size: 12px; line-height: 1.5'

  document.cookie = `🍪=${encodeURIComponent(POEM)}; path=/; max-age=31536000`

  localStorage.setItem('dev', JSON.stringify({
    nome: 'Matheus Edson',
    funcao: 'Growth Engineer',
    cidade: 'Uberlândia, Brasil',
    contato: 'linharesmatheus29@gmail.com',
    github: 'github.com/MatheusEdson',
    codigo_da_cacada: 'PERSISTE',
    segredo: 'você achou o localStorage. tem mais: /humans.txt, /sitemap.xml, /.well-known/security.txt',
  }))

  // dataLayer: inicializa vazio (normalmente o GTM faz isso)
  // Sem GTM instalado o array existe mas fica vazio — é o comportamento esperado
  window.dataLayer = window.dataLayer || []

  // Lição 16/20: window.__matheus — visível no Memory > Heap Snapshot
  class GrowthEngineer_MatheusEdson {
    licao = '16/20'
    codigo_da_cacada = 'MEMORIA'
    sobre = 'Memory > Take heap snapshot > busque "GrowthEngineer_MatheusEdson". Classes nomeadas aparecem agrupadas no heap. window.__ e convencao para expor dados de debug sem poluir o namespace global. Redux DevTools usa isso internamente.'
    nome = 'Matheus Edson'
    funcao = 'Growth Engineer'
    contato = 'linharesmatheus29@gmail.com'
  }
  window.__matheus = new GrowthEngineer_MatheusEdson()

  // Lição 15/20: performance marks — visíveis em Performance > Timings
  performance.mark('📍 licao-15/20 | codigo: TIMING')
  performance.measure(
    '📍 codigo-da-cacada: TIMING | licao-15/20 | matheusedson.com',
    '📍 licao-15/20 | codigo: TIMING'
  )

  // Lição 12/20: sessionStorage
  sessionStorage.setItem('licao', '12/20')
  sessionStorage.setItem('codigo_da_cacada', 'EFEMERA')
  sessionStorage.setItem('📖', 'Licao 12/20: voce esta no sessionStorage. Diferente do localStorage: quando voce fecha a aba, tudo some. Nao persiste entre abas ou sessoes. O GA4 usa internamente o session_id em sessionStorage para agrupar eventos de uma mesma visita.')

  // Lição 13/20: IndexedDB
  try {
    const req = indexedDB.open('matheusedson', 1)
    req.onupgradeneeded = (e: IDBVersionChangeEvent) => {
      const db = (e.target as IDBOpenDBRequest).result
      if (!db.objectStoreNames.contains('sobre')) {
        db.createObjectStore('sobre', { keyPath: 'id' })
      }
    }
    req.onsuccess = (e: Event) => {
      const db = (e.target as IDBOpenDBRequest).result
      const tx = db.transaction('sobre', 'readwrite')
      tx.objectStore('sobre').put({
        id: 1,
        licao: '13/20',
        codigo_da_cacada: 'BANCO',
        sobre: 'IndexedDB e um banco de dados completo no browser. Persiste entre sessoes, suporta indices, queries e transacoes. PWAs usam para funcionar offline. GA4 usa internamente para batch de eventos antes de enviar. Diferente de localStorage: suporta objetos complexos, arquivos e blobs. Limite: geralmente 80% do disco disponivel. F12 > Application > IndexedDB > matheusedson.',
        nome: 'Matheus Edson',
        contato: 'linharesmatheus29@gmail.com',
        poema: POEM,
      })
    }
  } catch (_) { /* IndexedDB indisponivel */ }

  // Lição 3/20: cookie com poema + cookie com lição sobre cookies
  const cookieLesson = [
    'Licao 3/20: voce esta lendo um cookie.',
    'Cookies sao dados que o browser guarda e envia em CADA request HTTP para o dominio.',
    'O _fbp e o pixel do Meta te rastreando. O _ga e o Google Analytics.',
    'iOS 14.5 (2021) destruiu cookies de terceiros: por isso first-party data vale ouro hoje.',
    'Nunca guarde dados grandes em cookies: eles aumentam o tamanho de todo request.',
  ].join(' ')
  document.cookie = `🍪=${encodeURIComponent(POEM)}; path=/; max-age=31536000`
  document.cookie = `📖=${encodeURIComponent(cookieLesson)}; path=/; max-age=31536000`
  document.cookie = `codigo_da_cacada=SAPO; path=/; max-age=31536000`

  // Lição 4/20: localStorage com dados do dev + lição sobre localStorage
  localStorage.setItem('dev', JSON.stringify({
    nome: 'Matheus Edson',
    funcao: 'Growth Engineer',
    cidade: 'Uberlândia, Brasil',
    contato: 'linharesmatheus29@gmail.com',
    github: 'github.com/MatheusEdson',
    codigo_da_cacada: 'PERSISTE',
  }))
  localStorage.setItem('codigo_da_cacada', 'PERSISTE')
  localStorage.setItem('📖', [
    'Licao 4/20: voce esta lendo o localStorage.',
    'Diferente de cookies: (1) nao e enviado em requests HTTP, o servidor nunca ve;',
    '(2) persiste indefinidamente ate limpeza manual; (3) nao tem expiracao.',
    'Para growth: GA4 e Meta Pixel nao leem localStorage diretamente.',
    'Voce precisa de eventos explicitos no dataLayer para rastrear qualquer estado aqui.',
    'Use para UX e estado de interface, nao para rastreamento de conversao.',
  ].join(' '))

  trackEgg('console')

  // Console: lição 1/20 (colapsada) + sapo + contato + game
  console.groupCollapsed(
    '%c⚡ lição 1/20 — CONSOLE  %c(clique para expandir)',
    'color: #EBEBEB; font-size: 12px; font-weight: 700; background: #1a1a2e; padding: 3px 8px; border-radius: 4px',
    'color: #555; font-size: 10px; font-weight: 400'
  )
  console.log(
    '%cVocê está no Console. É a primeira aba que um dev abre.\n\nAqui o JavaScript da página fala com você.\nO mais importante para growth é o dataLayer:\n\n    dataLayer.push({event: "purchase", value: 99})\n\nEsse comando dispara uma conversão no Google Tag Manager.\nSe ele não aparecer quando o usuário compra, você está\nperdendo dados sem saber. Cole "dataLayer" no console\npara ver o estado atual. Filtre por "GTM" para ver\ntodas as tags disparando em tempo real.',
    'color: #9CA3AF; font-size: 11px; line-height: 1.9; font-family: monospace'
  )
  console.groupEnd()

  console.log('%c' + FROG, `color: #4ADE80; ${mono}`)
  console.log('%cMENSAGEM', 'color: #E8E8E8; font-size: 11px; font-weight: 700; letter-spacing: 0.12em')
  console.log(
    '%cCanal de contato mais fácil para recrutadores\n→ linharesmatheus29@gmail.com',
    'color: #E8E8E8; font-size: 13px; line-height: 1.9'
  )
  console.log(
    '%cEnquanto manda uma msg que tal jogar um jogo →  game()',
    'color: #F59E0B; font-size: 13px; font-weight: 600; padding-top: 2px'
  )
  console.log(
    '%c💡 dica: abra Performance, clique no circulo, recarregue, stop. Procure a secao Timings.',
    'color: #444; font-size: 10px; font-family: monospace; padding-top: 4px'
  )
  console.log(
    '%c🎯 codigo da cacada (cole em /stats): CONSOLE',
    'color: #4ADE80; font-size: 12px; font-weight: 700; padding-top: 6px; font-family: monospace'
  )
  console.log('%c ', mono)

  // Game
  window.game = function () {
    const state = { hp: 100, gold: 0, floor: 0, maxFloor: 3 }

    const enemies = [
      { name: 'PHP Dev sem Framework', hp: 28, atk: 7, gold: 12 },
      { name: 'Bot de LinkedIn', hp: 42, atk: 13, gold: 22 },
      { name: 'Reunião Sem Pauta', hp: 65, atk: 20, gold: 45 },
    ]

    const log = (msg: string, style = 'color:#E8E8E8; font-size:13px') =>
      console.log('%c' + msg, style)

    const hud = () =>
      log(
        `❤  HP ${state.hp}/100   💰 ${state.gold} gold   🚪 Andar ${state.floor}/${state.maxFloor}`,
        'color:#A78BFA; font-weight:600; font-size:12px'
      )

    function battle(enemy: { name: string; hp: number; atk: number; gold: number }) {
      let eHp = enemy.hp
      log(`\n⚠  ${enemy.name} bloqueia o caminho!  (HP: ${eHp})`, 'color:#F87171; font-weight:700')

      while (state.hp > 0 && eHp > 0) {
        hud()
        const act = prompt(`O que fazer?\n[a] atacar\n[f] fugir`)?.toLowerCase().trim()

        if (act === 'f') {
          const flee = Math.floor(Math.random() * 8) + 4
          state.hp = Math.max(0, state.hp - flee)
          log(`Você fugiu... levou ${flee} de dano na fuga.`, 'color:#FCD34D')
          return 'fled'
        }

        const dmg = Math.floor(Math.random() * 18) + 10
        eHp = Math.max(0, eHp - dmg)
        log(`⚔  Você causou ${dmg} de dano.  ${enemy.name} HP: ${eHp}`, 'color:#34D399')

        if (eHp <= 0) {
          log(`✅ ${enemy.name} derrotado!  +${enemy.gold} gold`, 'color:#FCD34D; font-weight:700')
          state.gold += enemy.gold
          return 'win'
        }

        const edm = Math.floor(Math.random() * enemy.atk) + 3
        state.hp = Math.max(0, state.hp - edm)
        log(`💥 ${enemy.name} causou ${edm} de dano.  Seu HP: ${state.hp}`, 'color:#F87171')
      }

      return state.hp <= 0 ? 'dead' : 'win'
    }

    function nextRoom() {
      state.floor++
      log(
        `\n🚪  Andar ${state.floor} — a porta range e se abre...`,
        'color:#818CF8; font-size:14px; font-weight:700'
      )

      const roll = Math.random()

      if (roll < 0.4) {
        const enemy = enemies[Math.min(state.floor - 1, enemies.length - 1)]
        const result = battle(enemy)
        if (result === 'dead') {
          log(
            '\n💀  GAME OVER\n   Você sucumbiu. Digite game() para tentar de novo.',
            'color:#F87171; font-size:15px; font-weight:700'
          )
          return false
        }
      } else if (roll < 0.62) {
        const found = Math.floor(Math.random() * 18) + 8
        state.gold += found
        log(`💰 Você encontrou ${found} gold escondido numa fenda na parede.`, 'color:#FCD34D')
      } else if (roll < 0.78) {
        const heal = Math.floor(Math.random() * 22) + 12
        state.hp = Math.min(100, state.hp + heal)
        log(`🧪 Poção de dados! +${heal} HP  →  HP atual: ${state.hp}`, 'color:#34D399')
      } else {
        log('👁  Silêncio absoluto. Algo observa da escuridão.', 'color:#555')
      }

      return true
    }

    console.clear()
    log(
      [
        '',
        '╔══════════════════════════════════════╗',
        '║   D U N G E O N   D O   G R O W T H  ║',
        '║           matheusedson.com            ║',
        '╚══════════════════════════════════════╝',
        '',
      ].join('\n'),
      'color:#F59E0B; font-family:monospace; font-size:13px; line-height:1.6'
    )
    log('3 andares. Sobreviva. Colete gold.', 'color:#E8E8E8')
    log('Comandos via prompt:  [a] atacar   [f] fugir\n', 'color:#555; font-size:11px')

    for (let i = 0; i < state.maxFloor; i++) {
      hud()
      const go = prompt(`Avançar para o próximo andar?\n[enter] sim    [n] não`)
      if (go?.toLowerCase().trim() === 'n') {
        log('\nVocê recuou. Covarde... mas sábio.', 'color:#555')
        log(`Gold coletado: ${state.gold}`, 'color:#FCD34D')
        return
      }
      if (!nextRoom()) return
    }

    hud()
    log(
      [
        '',
        '🏆  VOCÊ VENCEU.',
        `   Gold: ${state.gold}   HP final: ${state.hp}/100`,
        '',
        '   "os dados vencem a escuridão"',
        '',
        '   🎯 codigo da cacada (cole em /stats): VENCEDOR',
        '',
      ].join('\n'),
      'color:#34D399; font-size:15px; font-weight:700'
    )
  }
}
